import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { InputWrapper } from 'components/Form/InputWrapper';
import { PlaceAutocomplete } from './PlaceAutocomplete';

export const PlacesField = ({ name, label = '', required = false, fullWidth = false, wrapperSx = {} }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <InputWrapper label={label} required={required} fullWidth={fullWidth} wrapperSx={wrapperSx} error={!!error}>
          <PlaceAutocomplete multiple value={field.value ?? []} onChange={field.onChange} error={error} />
        </InputWrapper>
      )}
    />
  );
};
